import { useCatchUpPlan } from '@shkola/api';
import { useTranslation } from 'react-i18next';
import { useCurrentContext } from '../app/ViewContext';
import { Spinner } from '../components/ui';
import { Block, INK, PageHead, TaskArt } from '../design/forms';
import { CatchUp } from '../student/CatchUp';

/**
 * «Догнати пропущене» on its own page: the home page keeps only a line of «Не забудь». «Форми 2»: the
 * title on the paper with how many are left and what it is, the lessons in one block under it.
 */
export function CatchUpPage() {
  const { t } = useTranslation();
  const ctx = useCurrentContext();
  const child = ctx.kind === 'student' || ctx.kind === 'guardian' ? ctx.child : undefined;
  const plan = useCatchUpPlan(child?.memberId ?? '');
  const items = plan.data ?? [];
  const left = items.filter((i) => !i.done).length;
  return (
    <div className="flex flex-col gap-4">
      <PageHead
        title={t('catchUp.title')}
        note={
          items.length === 0
            ? undefined
            : left > 0
              ? t('catchUp.left', { count: left })
              : t('catchUp.allDone')
        }
        sub={items.length > 0 ? t('catchUp.hint') : undefined}
      />
      {child && plan.isPending ? (
        <Spinner />
      ) : !child || items.length === 0 ? (
        <Block>
          <div className="flex flex-col items-center py-12 text-center">
            <TaskArt kind="done" tone="lime" size={96} />
            <p className="mt-3 font-display text-[26px] font-light" style={{ color: INK }}>
              {t('catchUp.allDone')}
            </p>
          </div>
        </Block>
      ) : (
        <CatchUp
          schoolId={ctx.schoolId}
          studentId={child.memberId}
          canTick={ctx.kind === 'student'}
          bare
        />
      )}
    </div>
  );
}
